export default {
    methods: {
        async fetchZipCode(zipcode) {
            const response = await axios.get(`zipcode/${zipcode}`);
            return response
        },
    },
};
